<template>
	<div class="container mx-auto p-4">
		<h1 class="text-2xl font-bold mb-4">Số lượng đăng ký: {{data.length}}</h1>
		<el-collapse class="grid grid-cols-1 gap-4">
			<el-collapse-item
				v-for="(entry, index) in data"
				:key="index"
				:name="index"
				class="bg-white p-4 rounded shadow-md border mt-3"
			>
				<template slot="title">
					<h2 class="text-xl font-semibold mb-2">{{ entry["Họ và tên"] }} ({{ entry["Ngày/Tháng/Năm sinh"] }})</h2>
				</template>
				<p class="text-gray-700"><strong>Địa chỉ email:</strong> {{ entry["Địa chỉ email"] }}</p>
				<p class="text-gray-700"><strong>Ngày sinh:</strong> {{ entry["Ngày/Tháng/Năm sinh"] }}</p>
				<p class="text-gray-700"><strong>Giới tính:</strong> {{ entry["Giới tính"] }}</p>
				<p class="text-gray-700"><strong>Dân tộc:</strong> {{ entry["Dân tộc"] }}</p>
				<p class="text-gray-700"><strong>Tôn giáo:</strong> {{ entry["Tôn giáo"] }}</p>
				<p class="text-gray-700"><strong>Địa chỉ thường trú:</strong> {{ entry["Địa chỉ thường trú"] }}</p>
				<p class="text-gray-700"><strong>Quê quán:</strong> {{ entry["Quê quán"] }}</p>
				<p class="text-gray-700"><strong>Số CCCD:</strong> {{ entry["Số CCCD "] }}</p>
				<p class="text-gray-700"><strong>Ngày cấp CCCD:</strong> {{ entry["Ngày cấp CCCD"] }}</p>
				<p class="text-gray-700"><strong>Nơi cấp CCCD:</strong> {{ entry["Nơi cấp CCCD"] }}</p>
				<p class="text-gray-700"><strong>Số điện thoại:</strong> {{ entry["Số điện thoại cá nhân (chính chủ)"] }}</p>
				<p class="text-gray-700"><strong>Số điện thoại của cha, mẹ:</strong> {{ entry["Số điện thoại của cha, mẹ (người thân)"] }}</p>
				<p class="text-gray-700"><strong>Facebook:</strong> <a :href="entry['Link trang cá nhân Facebook']" target="_blank" class="text-blue-600 underline">Xem trang cá nhân</a></p>
				<p class="text-gray-700"><strong>Đối tượng:</strong> {{ entry["Sinh viên thuộc đối tượng"] }}</p>
				<p class="text-gray-700"><strong>Trúng tuyển trường:</strong> {{ entry["Trúng truyển trường"] }}</p>
				<p class="text-gray-700"><strong>Chương trình đào tạo:</strong> {{ entry["Chương trình đào tạo"] }}</p>
				<p class="text-gray-700"><strong>Ngành trúng tuyển:</strong> {{ entry["Ngành trúng tuyển"] }}</p>
				<p class="text-gray-700"><strong>Phương thức xét tuyển:</strong> {{ entry["Phương thức xét tuyển đại học?"] }}</p>
				<p class="text-gray-700"><strong>Điểm trúng tuyển:</strong> {{ entry["Điểm trúng tuyển?"] }}</p>
				<p class="text-gray-700"><strong>Bạn có anh/chị nào đã hoặc đang ở KTX:</strong> {{ entry["Bạn có anh/chị nào đã hoặc đang ở KTX"] }}</p>
				<p class="text-gray-700"><strong>Hoàn cảnh gia đình:</strong> {{ entry["Hoàn cảnh gia đình"] }}</p>
				<p class="text-gray-700"><strong>Định hướng và ước mơ:</strong> {{ entry["Định hướng và ước mơ trong tương lai (Dưới 1000 kí tự)"] }}</p>
				<p class="text-gray-700"><strong>Thành tích học tập:</strong> {{ entry["Thành tích học tập"] }}</p>
				<p class="text-gray-700"><strong>Ảnh thẻ:</strong> <a :href="entry['Ảnh thè (4x6)']" target="_blank" class="text-blue-600 underline"> Xem ảnh</a></p>
				<p class="text-gray-700"><strong>Ảnh nhà:</strong> <a :href="entry['Hình cảnh căn nhà đang ở']" target="_blank" class="text-blue-600 underline"> Xem ảnh</a></p>
			</el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
import Papa from 'papaparse';

export default {
	data() {
		return {
			data: [],
		};
	},
	created() {
		const csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSOSdM6qQTGMHhknoc_OCMUMxC-lZrOiFRM3LI6Btw7bAnn8Lrb4k3nVByxxk8v07dcwXl6TEvgeV_d/pub?gid=374012460&single=true&output=csv';
		Papa.parse(csvUrl, {
			download: true,
			header: true,
			complete: (results) => {
				this.data = results.data;
			},
		});
	},
};
</script>
